/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button } from "antd";
import { useGetTagsQuery } from "../../../../app/features/admin/admin.api";
import type { Tag } from "../../../../app/features/admin/admin.types";
import AddIcon from "../../../../assets/icons/AddIcon";
import CustomTable from "../../../../components/CustomTable";
import CustomTitle from "../../../../components/CustomTitle";
import StatusTag from "../../../../components/StatusTag";
import useFilters from "../../../../hooks/useFilters";
import useModal from "../../../../hooks/useModal";
import DashboardLayout from "../../../../layouts/DashboardLayout";
import type { ColumnsType } from "../../../../types/global.types";
import { countParPageSerialNumber } from "../../../../utils/global.utils";
import TagDetails from "./_components/TagDetails";
import TagModal from "./_components/TagModal";

const Tags = () => {
  const {
    page,
    limit,
    handleLimit,
    // handleSearch,
    // handleFilter,
    handlePagination,
  } = useFilters<{
    status?: string | undefined;
    search?: string | undefined;
  }>();
  const { open, handleOpen, handleClose } = useModal<Tag>();
  const { data, isLoading } = useGetTagsQuery();

  //   const [deleteTag] = useDeleteTagMutation();

  //   const handleDelete = (id: number) => {
  //     Modal.confirm({
  //       title: "Are you sure you want to delete this tag?",
  //       content: "This action cannot be undone.",
  //       okText: "Yes, Delete",
  //       okType: "danger",
  //       cancelText: "No",
  //       onOk: async () => {
  //         try {
  //           await deleteTag({ id }).unwrap();
  //           toast("success", "Tag deleted successfully");
  //         } catch (error: any) {
  //           toast("error", error?.data?.message || "Failed to delete tag");
  //         }
  //       },
  //     });
  //   };

  const statusOptions = [
    { label: "Active", value: "true", className: "status-success" },
    { label: "Inactive", value: "false", className: "status-error" },
  ];

  const columns: ColumnsType<Tag> = [
    {
      key: "sl",
      title: "#SL",
      align: "center",
      width: 60,
      render: (_: any, __: any, index: number) =>
        countParPageSerialNumber(page, limit, index),
    },
    {
      key: "name",
      title: "Name",
      dataIndex: "name",
    },
    // {
    //   key: "slug",
    //   title: "Slug",
    //   dataIndex: "slug",
    // },
    {
      key: "isActive",
      title: "Status",
      dataIndex: "isActive",
      render: (isActive: boolean) => (
        <StatusTag value={isActive ? "true" : "false"} config={statusOptions} />
      ),
    },
    // {
    //   key: "action",
    //   title: "Action",
    //   align: "end",
    //   width: 100,
    //   render: (_: any, record: Tag) => (
    //     <Dropdown
    //       overlayClassName="w-36"
    //       placement="bottomRight"
    //       menu={{
    //         items: [
    //           {
    //             key: "view",
    //             label: (
    //               <Flex align="center" gap={8}>
    //                 <Flex justify="center" className="w-6 text-theme-sky-500">
    //                   <ViewIcon size={24} />
    //                 </Flex>
    //                 <span className="text-sm font-medium">View</span>
    //               </Flex>
    //             ),
    //             onClick: () => handleOpen({ type: "VIEW", data: record }),
    //           },
    //           {
    //             key: "edit",
    //             label: (
    //               <Flex align="center" gap={8}>
    //                 <Flex
    //                   justify="center"
    //                   className="w-6 text-theme-yellow-500"
    //                 >
    //                   <EditIcon size={18} />
    //                 </Flex>
    //                 <span className="text-sm font-medium">Edit</span>
    //               </Flex>
    //             ),
    //             onClick: () => handleOpen({ type: "UPDATE", data: record }),
    //           },
    //           {
    //             key: "delete",
    //             label: (
    //               <Flex align="center" gap={8}>
    //                 <Flex justify="center" className="w-6 text-theme-error-500">
    //                   <DeleteIcon size={16} />
    //                 </Flex>
    //                 <span className="text-sm font-medium">Delete</span>
    //               </Flex>
    //             ),
    //             onClick: () => handleDelete(record?.id),
    //           },
    //         ],
    //       }}
    //       trigger={["click"]}
    //     >
    //       <Button
    //         type="text"
    //         size="small"
    //         icon={<ActionIcon />}
    //         classNames={{ icon: "!size-8 flex items-center justify-center" }}
    //       />
    //     </Dropdown>
    //   ),
    // },
  ];

  return (
    <DashboardLayout title="Tags">
      <CustomTitle title="Tag Management" description="Manage all course tags">
        <Button
          onClick={() => handleOpen({ type: "ADD" })}
          className="btn-primary"
        >
          <AddIcon /> Add New Tag
        </Button>
      </CustomTitle>

      <CustomTable
        total={10}
        page={page}
        limit={limit}
        loading={isLoading}
        columns={columns}
        dataSource={Array.isArray(data) ? data : []}
        onLimitChange={handleLimit}
        onPaginate={handlePagination}
        tableTitle="All Tags"
        hideRowSelect
        // filterSection={
        //   <Flex align="center" gap={8}>
        //     <Input
        //       size="middle"
        //       placeholder="Search tag"
        //       prefix={<SearchIcon size={14} />}
        //       className="max-w-[200px] input-bordered"
        //       onChange={handleSearch}
        //     />
        //     <Select
        //       allowClear
        //       size="middle"
        //       placeholder="Status"
        //       style={{ width: 120 }}
        //       className="input-bordered"
        //       options={[
        //         { label: "Active", value: "active" },
        //         { label: "Inactive", value: "inactive" },
        //       ]}
        //       onChange={(val) => handleFilter("status", val)}
        //     />
        //   </Flex>
        // }
      />

      {(open?.type === "ADD" || open?.type === "UPDATE") && (
        <TagModal
          open={open?.open}
          onCancel={handleClose}
          initialValues={open?.data}
          type={open?.type}
        />
      )}

      {open?.type === "VIEW" && (
        <TagDetails
          open={open?.open}
          onCancel={handleClose}
          tag={open?.data}
          type={open?.type}
        />
      )}
    </DashboardLayout>
  );
};

export default Tags;
